import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiAward, FiTrendingUp, FiUsers } = FiIcons;

const AuthoritySection = () => {
  const logos = [
    {
      name: "Apps Camelot",
      url: "https://appscamelot.com/wp-content/uploads/2025/08/appscamelot-logo-600.png"
    },
    {
      name: "Ticket Factura",
      url: "https://appscamelot.com/wp-content/uploads/2025/08/logo-tf-300.png"
    },
    {
      name: "WAiBOT",
      url: "https://appscamelot.com/wp-content/uploads/2025/08/waibot-logo.png"
    },
    {
      name: "PV1",
      url: "https://appscamelot.com/wp-content/uploads/2025/08/pv1-logo.png"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <motion.div 
          className="max-w-4xl mx-auto text-center"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="flex flex-col md:flex-row items-center gap-8 mb-8">
            <div className="w-32 h-32 rounded-full overflow-hidden shadow-lg">
              <img 
                src="https://appscamelot.com/wp-content/uploads/2025/08/foto-carlos-serafin.jpg"
                alt="Carlos Serafín"
                className="w-full h-full object-cover"
              />
            </div>
            
            <div className="flex-1 text-left">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                Carlos Serafín
              </h2>
              <p className="text-xl text-gray-600 mb-4">
                Experto en Tecnología para Restaurantes
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Con más de <span className="text-orange-600 font-semibold">15 años de experiencia</span> ayudando a restaurantes mexicanos a modernizarse y aumentar la calidad de atención y hospitalidad usando tecnología e inteligencia artificial.
              </p>
            </div>
          </div>

          {/* Company logos section */}
          <motion.div 
            className="mb-12"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <h3 className="text-xl font-semibold text-gray-700 mb-6">Nuestras empresas:</h3>
            <div className="flex flex-wrap justify-center items-center gap-8">
              {logos.map((logo, index) => (
                <motion.div 
                  key={index}
                  className="h-16 flex items-center justify-center"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                >
                  <img 
                    src={logo.url} 
                    alt={logo.name}
                    className="max-h-full max-w-[140px] object-contain"
                  />
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Team Banner */}
          <motion.div 
            className="mb-12 flex justify-center"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <div className="relative w-[60%]">
              <img 
                src="https://appscamelot.com/wp-content/uploads/2025/08/1753813051016-camelot-caballeros.jpg"
                alt="Equipo Profesional de Automatización con IA"
                className="w-full rounded-lg shadow-xl"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end justify-center rounded-lg">
                <h3 className="text-white text-xl md:text-2xl font-bold mb-4 px-2 text-center">
                  Nuestro Equipo Profesional de Automatización con IA
                </h3>
              </div>
            </div>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-8">
            <motion.div 
              className="bg-gradient-to-br from-orange-100 to-red-100 p-6 rounded-lg shadow-lg"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              <SafeIcon icon={FiTrendingUp} className="text-4xl text-orange-600 mb-4 mx-auto" />
              <h3 className="text-2xl font-bold text-gray-800 mb-2">+30%</h3>
              <p className="text-gray-600">De aumento en el nivel de hospitalidad y atención a tus clientes</p>
            </motion.div>

            <motion.div 
              className="bg-gradient-to-br from-yellow-100 to-orange-100 p-6 rounded-lg shadow-lg"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              <SafeIcon icon={FiUsers} className="text-4xl text-yellow-600 mb-4 mx-auto" />
              <h3 className="text-2xl font-bold text-gray-800 mb-2">100+</h3>
              <p className="text-gray-600">Restaurantes transformados exitosamente</p>
            </motion.div>

            <motion.div 
              className="bg-gradient-to-br from-red-100 to-pink-100 p-6 rounded-lg shadow-lg"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              <SafeIcon icon={FiAward} className="text-4xl text-red-600 mb-4 mx-auto" />
              <h3 className="text-2xl font-bold text-gray-800 mb-2">15 años</h3>
              <p className="text-gray-600">De experiencia en el sector gastronómico</p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AuthoritySection;